// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_7j-4";
export var collapsed = "_7j-1";
export var headerBar = "_7j-0";
export var leftHeaderContent = "_7j-3";
export var subjectContainer = "_7j-2";